import { useLanguage } from "../../../context/LanguageContext";
import { Card, CardContent } from "../../../components/ui/card";
import { AlertTriangle, Crown, Pin, UserSquare2 } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";
import { Button } from "../../../components/ui/button";
import { Link, useNavigate } from "react-router-dom";
import { BarCharLabel } from "../../../components/Charts/BarCharLabel";
import { DonutWithText } from "../../../components/Charts/DonutWithText";
import StarRating from "../../../components/StarRating";

export default function AdminTeachers() {
  const { language } = useLanguage();
  const navigate = useNavigate();
  
  return (
    <div className="space-y-6" dir={language === "ar" ? "rtl" : "ltr"}>
      <Card className="border-2 border-blue-600">
        <CardContent className="p-4 text-center rounded-2xl grid grid-cols-1 lg:grid-cols-2 gap-4">
          {/* Teacher Card */}
          <div className="flex gap-2 items-center lg:items-end flex-col lg:flex-row">
            <div className="text-center w-full lg:w-fit flex flex-col items-center gap-2">
              <UserSquare2 className="text-blue-600 size-8" />
              <p className="text-muted-foreground text-xs font-medium">
                Number of teachers on the platform
              </p>
              <div className="flex items-center gap-2">
                <p className="font-bold text-2xl lg:text-xl">15 teachers</p>
                {true && (
                  <div className="border-2 border-green-500 text-green-500 py-1 px-2 rounded-full text-xs font-semibold h-fit mt-1">
                    +0.7%
                  </div>
                )}
              </div>
            </div>
            <div className="flex items-center -space-x-3">
              {/* Avatar */}
              {[1, 2, 3, 4, 5].map((_, i) => (
                <div
                  key={i}
                  className="w-10 h-10 rounded-full overflow-hidden border-4 border-background"
                >
                  <img
                    src={
                      "https://s3-alpha-sig.figma.com/img/3260/3aa2/bb5a605bdf4f394aa9dbfdb440bdd68e?Expires=1741564800&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=QXIda0oKq6EUJU~W~T9HiFyUXQsjyKD9IACEkywPnHrfy~OAnk5ixwtkpygNEB5czFUM8YJfhp5nix5YLDKx7wMOJu91VPfpV2O08jMMpEfalC1AH9OQBu8P3tsR4mmFxAVKt~RTkNPySfMW7x~ZbNt7S9fsDNATK7gxbevFE-nq25pHHJN~NzsB8o9NF~r8pVDzjDj8Q6qlttu3Kn5j8jF4M1xewzDNldSGBL1RTjB-gOg0dUEW5hFXokFQA4~Dxvw72FjSoZnqbMsmsLRJ6i6HAbhH8lprHoHr2GFfkeKdZKL~ccXPyvJIbUMnqhcoCqZkvkM0CxsYTpjxhAL~xg__"
                    }
                    alt={"Avatar"}
                    loading="lazy"
                    className="object-cover"
                  />
                </div>
              ))}
            </div>
          </div>
          {/* Actions */}
          <div className="flex items-center justify-end flex-wrap sm:flex-nowrap gap-4">
            <Button
              className="w-full lg:w-fit h-10 bg-blue-600 text-white hover:bg-blue-600/80 rounded-full"
              onClick={() => navigate("/admin/all-teachers")}
            >
              Show
            </Button>
            <Button
              variant="outline"
              className="w-full lg:w-fit h-10 border-2 border-blue-600 text-blue-600 hover:text-blue-500 rounded-full"
            >
              Add a Teacher
            </Button>
          </div>
        </CardContent>
      </Card>
      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-6">
        {/* Chart 1 */}
        <div className="max-w-xl w-full space-y-4 text-center mx-auto">
          <div className="flex items-center justify-between flex-wrap">
            <p className="font-bold text-xl">Number of lectures offered</p>

            <Select defaultValue="week">
              <SelectTrigger className="w-fit border-none focus:ring-0 justify-start gap-1 p-0 shadow-none">
                <p className="text-muted-foreground text-sm">
                  <SelectValue placeholder={"Time"} />
                </p>
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="week">Week</SelectItem>
                <SelectItem value="month">Month</SelectItem>
                <SelectItem value="year">Year</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <BarCharLabel
            color={"#2563eb"}
            footerTitle={"Number of monthly subscriptions"}
          />
        </div>

        {/* Chart 2 */}
        <div className="max-w-xl w-full space-y-4 text-center mx-auto">
          <div className="flex items-center justify-between flex-wrap">
            <p className="font-bold text-xl">Number of students attending</p>

            <Select defaultValue="egyptian">
              <SelectTrigger className="w-fit border-none focus:ring-0 justify-start gap-1 p-0 shadow-none">
                <p className="text-muted-foreground text-sm">
                  <SelectValue placeholder={"curriculum"} />
                </p>
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="egyptian">Egyptian</SelectItem>
                <SelectItem value="english">English</SelectItem>
                <SelectItem value="both">Both</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="">
            <DonutWithText />
          </div>
        </div>
      </div>
      {/* Rating */}
      <div className="space-y-4">
        {/* Title */}
        <div className="flex items-center justify-between flex-wrap">
          <p className="font-bold text-xl">Teachers rating</p>

          <Select defaultValue="">
            <SelectTrigger className="w-fit border-none focus:ring-0 justify-start gap-1 p-0 shadow-none">
              <p className="text-muted-foreground text-sm">
                <SelectValue placeholder={"According to student rating"} />
              </p>
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="week">Week</SelectItem>
              <SelectItem value="month">Month</SelectItem>
              <SelectItem value="year">Year</SelectItem>
            </SelectContent>
          </Select>
        </div>
        {/* Table */}
        <Card className="border-2 border-blue-600 overflow-auto">
          <CardContent className="p-4 space-y-4">
            <table className="w-full text-base">
              <tbody>
                {[1, 2, 3, 4].map((_, index) => (
                  <tr className="">
                    {/* Name & Rank */}
                    <td className="p-2 font-bold flex items-center gap-4 whitespace-nowrap md:whitespace-normal">
                      <div className="relative inline-block">
                        <span>{index + 1}</span>
                        {index + 1 === 1 && (
                          <div className="absolute -top-4 -left-1">
                            <Crown className="size-5 text-yellow-400 fill-yellow-400" />
                          </div>
                        )}
                      </div>
                      <span>Professor Mohamed Abdel Hamid</span>
                    </td>

                    {/* Subject */}
                    <td className="p-2 font-medium whitespace-nowrap">
                      German language
                    </td>

                    {/* Comments */}
                    <td className="p-2 font-medium whitespace-nowrap">
                      78 comments
                    </td>

                    {/* Rating */}
                    <td className="p-2 font-medium whitespace-nowrap flex items-center gap-2">
                      {index + 1} /5 <StarRating rating={index + 1} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </CardContent>
        </Card>
      </div>
      {/* Alerts */}
      <div className="space-y-4">
        {/* Title */}
        <div className="flex items-center justify-between flex-wrap">
          <p className="font-bold text-xl">Alerts</p>

          <div className="flex items-center gap-4">
            <Button
              variant="link"
              className="text-muted-foreground p-0 font-normal"
              asChild
            >
              <Link to="/">View all alerts</Link>
            </Button>

            <Select defaultValue="">
              <SelectTrigger className="w-fit border-none focus:ring-0 justify-start gap-1 p-0 shadow-none">
                <p className="text-muted-foreground text-sm">
                  <SelectValue placeholder={"According alerts"} />
                </p>
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="week">Week</SelectItem>
                <SelectItem value="month">Month</SelectItem>
                <SelectItem value="year">Year</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        {/* Messages 1 */}
        <div className="bg-secondary p-4 rounded-xl space-y-4">
          <div className="flex items-center gap-2">
            <AlertTriangle className="fill-yellow-400 text-white size-7 stroke-1" />
            <p className="font-bold text-xl">️Low rating for a teacher</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">
            <p className="font-medium text-lg border-l-2 border-blue-600 px-2">
              “Teacher Khaled Hassan received a rating of 2/5 from 3 students
              this week.”Subject: German language
            </p>

            <div className="flex items-center justify-end flex-wrap sm:flex-nowrap gap-4">
              <Button className="w-full lg:w-fit h-10 bg-blue-600 text-white hover:bg-blue-600/80 rounded-full">
                Message the teacher
              </Button>
              <Button
                variant="outline"
                className="w-full lg:w-fit h-10 border-2 border-blue-600 text-blue-600 hover:text-blue-500 rounded-full"
              >
                View ratings
              </Button>
            </div>
          </div>
        </div>
        {/* Messages 2 */}
        <div className="bg-secondary p-4 rounded-xl space-y-4">
          <div className="flex items-center gap-2">
            <Pin className="fill-red-500 text-white size-7 stroke-1" />
            <p className="font-bold text-xl">New content awaiting review</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">
            <p className="font-medium text-lg border-l-2 border-blue-600 px-2">
              “Teacher Sarah uploaded a new lesson plan for physics.”
            </p>

            <div className="flex items-center justify-end flex-wrap sm:flex-nowrap gap-4">
              <Button className="w-full lg:w-fit h-10 bg-blue-600 text-white hover:bg-blue-600/80 rounded-full">
                View details
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
